import "./shared.scss"
import React from 'react';

interface Props {
    className?: string
    style?: React.CSSProperties
    text: string,
    onClick?: () => void
}
type StringOrUndefined = string | undefined
const StyledButton = (props: Props) => {
    const { className, style, text, onClick } = props
    const combineClasses = (...args: StringOrUndefined[]): string => {
        return args.join(" ")
    }

    return (<>
        <button
            type="button"
            style={style}
            onClick={() => { if (onClick) onClick() }}
            className={combineClasses(className, "emp-styled-btn")} >{text}</button>
    </>)
}
export default StyledButton